import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import SectionContainer from '../../containers/PageBuilder/SectionBuilder/SectionContainer';

import StepList from './StepList';
import MarketFlow from '../MarketFlow';

// Der animierte Marktfluss ueber der Schrittliste. Auf true setzen, um ihn
// wieder zu zeigen.
const ZEIGE_MARKTFLUSS = false;
import css from './SectionSteps.module.css';

/**
 * FairwayBid: Der Ablauf als nummerierte Strecke.
 *
 * Vorher standen hier drei gleich aussehende Textspalten. Dass es sich um
 * eine Reihenfolge handelt - erst einstellen, dann Angebote, dann
 * vergleichen -, musste man sich aus dem Text erschließen.
 *
 * Die Nummerierung und die Linie dazwischen sind deshalb keine Verzierung:
 * Sie sind die Aussage. Genau drei Schritte, in dieser Reihenfolge, und
 * dann ist man fertig. Das ist das Verkaufsargument dieses Abschnitts.
 *
 * Inhalt bleibt vollständig in der Console. Fügt Tom einen vierten Block
 * hinzu, wird daraus Schritt 04.
 */
const SectionSteps = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  // Der Abschnitt steht auf dunklem Grund. Statt die Klasse des Templates zu
  // erraten, lesen wir dieselbe Angabe, aus der auch das Template sie ableitet.
  const aufDunkel = appearance?.textColor === 'white';

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {/*
        Dieselbe Kopfzeile wie bei "Warum FairwayBid?": mittig, kurzer
        Strich, darunter der Leadsatz. Zwei Abschnitte direkt untereinander
        muessen gleich anfangen, sonst wirkt die Seite zusammengesetzt.
      */}
      {hasHeaderFields ? (
        <header className={classNames(css.header, { [css.onDark]: aufDunkel })}>
          <Field data={title} className={css.headTitle} options={fieldOptions} />
          <span className={css.rule} aria-hidden="true" />
          <Field data={description} className={css.intro} options={fieldOptions} />
          <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
        </header>
      ) : null}

      {/*
        Die Bewegung steht ueber der Schrittliste, nicht darunter: Sie zeigt
        in sechs Sekunden, was die drei Schritte darunter in Worten sagen.
        Wer sie gesehen hat, liest die Schritte als Bestaetigung - wer sie
        nicht sieht, verliert nichts.

        Vorerst ausgeblendet. Der Baustein bleibt stehen, samt seinem CSS -
        er ist fertig und geprueft, und ihn zu loeschen hiesse, ihn spaeter
        noch einmal zu bauen. Ein Schalter statt einer Loeschung: Auf true
        gesetzt, ist er wieder da.
      */}
      {ZEIGE_MARKTFLUSS ? <MarketFlow onDark={aufDunkel} /> : null}

      <StepList
        onDark={aufDunkel}
        steps={blocks.map(block => ({
          title: block?.title?.content,
          text: block?.text?.content,
        }))}
      />
    </SectionContainer>
  );
};

export default SectionSteps;
